import { render, staticRenderFns } from "./password.vue?vue&type=template&id=bd886eb2&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "./password.vue?vue&type=style&index=0&id=bd886eb2&scoped=true&lang=css&"
import style1 from "./password.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd886eb2",
  null
  
)

export default component.exports